import { Link } from "wouter";
import { Zap } from "lucide-react";
import { Button } from "@/components/ui/button";

export function SiteFooter() {
  return (
    <footer className="w-full border-t border-white/5 bg-black py-12" data-testid="site-footer">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-10 pb-10 border-b border-white/5">
          <p className="text-sm text-white/40">
            Already have an account?{" "}
            <Link href="/signup" className="text-white/70 hover:text-white underline underline-offset-2 transition-colors" data-testid="link-footer-signin">
              Sign In
            </Link>
          </p>
          <Link href="/signup">
            <Button className="bg-blue-600 hover:bg-blue-500 text-white border-0 shadow-lg shadow-blue-600/20 gap-2" data-testid="button-footer-get-started">
              Get Started Free →
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <Link href="/" className="flex items-center gap-2 mb-4">
              <div className="w-6 h-6 rounded-md bg-blue-600 flex items-center justify-center">
                <Zap size={14} className="text-white" fill="white" />
              </div>
              <div className="flex items-baseline gap-0.5">
                <span className="text-base font-display font-black tracking-tight text-white">Drpr</span>
                <span className="text-base font-display font-black tracking-tight text-blue-400">.ai</span>
              </div>
            </Link>
            <p className="text-sm text-white/40 leading-relaxed">
              The world's first autonomous AI marketing workforce. Scale your business with Draper, Peggy, Pete, and Rogers.
            </p>
          </div>
          
          <div>
            <h4 className="text-sm font-bold text-white mb-4 uppercase tracking-wider">Product</h4>
            <ul className="space-y-2">
              <li><Link href="/#features" className="text-sm text-white/40 hover:text-white transition-colors">Features</Link></li>
              <li><Link href="/#pricing" className="text-sm text-white/40 hover:text-white transition-colors">Pricing</Link></li>
              <li><Link href="/status" className="text-sm text-white/40 hover:text-white transition-colors">Status</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4 uppercase tracking-wider">Company</h4>
            <ul className="space-y-2">
              <li><Link href="/blog" className="text-sm text-white/40 hover:text-white transition-colors">Blog</Link></li>
              <li><Link href="/privacy" className="text-sm text-white/40 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link href="/terms" className="text-sm text-white/40 hover:text-white transition-colors">Terms of Service</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4 uppercase tracking-wider">Resources</h4>
            <ul className="space-y-2">
              <li><Link href="/about" className="text-sm text-white/40 hover:text-white transition-colors">About Us</Link></li>
              <li><Link href="/about#contact" className="text-sm text-white/40 hover:text-white transition-colors">Contact</Link></li>
              <li><Link href="/why-drpr#faq" className="text-sm text-white/40 hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[10px] text-white/20 uppercase tracking-widest font-bold">
            © {new Date().getFullYear()} DRPR.AI - AUTONOMOUS MARKETING ENGINE
          </p>
          <p className="text-[10px] text-white/20 uppercase tracking-widest font-bold">
            A Lejjors Corp. Project · AI Governance Patent Pending
          </p>
        </div>
      </div>
    </footer>
  );
}
